<template>
  <div>
    <Header
      v-if="!this.$store.getters.iframeColidee"
      :window="window"
      :parameters="'attendeesAdmin'"
    />
    <AttendeesAdmin />
    <Footer v-if="!this.$store.getters.iframeColidee" :window="window" />
  </div>
</template>

<script>
import Header from "@/components/layout/Header";
import Footer from "@/components/layout/Footer";
import AttendeesAdmin from "@/components/attendees/AttendeesAdmin";

export default {
  name: "attendees",
  components: {
    Header,
    Footer,
    AttendeesAdmin
  },
  data() {
    return {
      window: {
        width: window.innerWidth
      }
    };
  },
  created() {
    window.addEventListener("resize", this.handleResize);
    this.handleResize();
  },
  destroyed() {
    window.removeEventListener("resize", this.handleResize);
  },
  methods: {
    handleResize() {
      this.window.width = window.innerWidth;
    }
  }
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/page/Attendees.vue